import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionRelatedTransactionsSearchCriteria extends ValueObject {
    public staticServiceProviderFileGroupingId: number | null = null;

    public corporateActionEventId: number | null = null;

    public instrument: string | null = null;
}